import { atomWithImmer } from "jotai-immer";

import type { CommandPaletteState } from "../types";

export const initialState: CommandPaletteState = {
  isVisible: false,
  query: "",
  highlightedIndex: 0,
  filterTokens: [],
};

export const commandPaletteAtom =
  atomWithImmer<CommandPaletteState>(initialState);
